import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { ENDERECO_CN, TELEFONE_CN, EMAIL_CN, CONTATOS_CN, LOGIN_USUARIO, IDENTIFICACAO_LOGIN, PAINEL_RISCOS } from '../../../app.constants';
import { ContatosModel } from '../models/contatos.model';
import { EmailPessoaModel } from '../models/email-pessoa.model';
import { EnderecoSchemaCadastroModel } from '../models/endereco-schema-cadastro.model';
import { IdentificacaoLoginDTO } from '../models/identificacaoLogin-DTO';
import { TelefonePessoaModel } from '../models/telefone-pessoa.model';


@Injectable()
export class EnderecoCadastroService {

  constructor(private httpClient: HttpClient) { }

  getToken() {
    return this.httpClient.get(`https://hml-springcloudzuul-app.centrus.org.br/api/auth`)
      .toPromise(); 
  }  

  redirecionarParaRelatorio(token: string) {
    const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
    });
    return this.httpClient.get(PAINEL_RISCOS, { headers, responseType: 'text'});
  }

  getEmail(centrus: number) {
    return this.httpClient
      .get(`${EMAIL_CN}/${centrus}`)
      .toPromise();
  }

  updateEmail(emailPessoaModel: EmailPessoaModel) {
    return this.httpClient
      .put(`${EMAIL_CN}`, emailPessoaModel)
      .toPromise();
  }


  getEndereco(centrus: number): Promise<EnderecoSchemaCadastroModel> {
    return this.httpClient
      .get<EnderecoSchemaCadastroModel>(`${ENDERECO_CN}/${centrus}`)
      .toPromise();
  }

  updateEndereco(enderecoSchemaCadastroModel: EnderecoSchemaCadastroModel) {
    return this.httpClient
      .put<EnderecoSchemaCadastroModel>(`${ENDERECO_CN}`, enderecoSchemaCadastroModel)
      .toPromise();
  }


  getTelefone(centrus: number) {
    return this.httpClient
      .get<TelefonePessoaModel>(`${TELEFONE_CN}/${centrus}`)
      .toPromise();
  }


  updateTelefone(telefonePessoaModel: TelefonePessoaModel) {
    return this.httpClient
      .put(`${TELEFONE_CN}`, telefonePessoaModel)
      .toPromise();
  }

  getContatoTipo() {
    return this.httpClient
      .get<Array<ContatosModel>>(`${CONTATOS_CN}`)
      .toPromise();
  }

  // atualizar usuário
  putLoginUsuario(form, paramsId) {
    return this.httpClient.put(`${LOGIN_USUARIO}/${paramsId}`, form)
    .toPromise();
  }


  putIdentificaoLogin(identificacao) {
    return this.httpClient.put(`${IDENTIFICACAO_LOGIN}`, identificacao)
    .toPromise();
  }


  // identificacao login
  getIdentificaoLogin(cdCentrus) {
    return this.httpClient
      .get<IdentificacaoLoginDTO[]>(`${IDENTIFICACAO_LOGIN}/byCdCentrus/${cdCentrus}`)
      .toPromise();
  }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/endereco-cadastro.service.ts